<div class="nacha-ach-token-selector-modal">
  <div class="modal-info">
    <mat-icon>account_balance</mat-icon>
    <p>Select an existing ACH bank account for <strong>{{ customerName }}</strong></p>
  </div>

  @if (achTokens.length === 0) {
    <div class="no-results">
      <mat-icon>account_balance_wallet</mat-icon>
      <p>No ACH tokens on file for this customer.</p>
    </div>
  } @else {
    <mat-radio-group [(ngModel)]="selectedToken" class="token-radio-group">
      @for (token of achTokens; track token.id) {
        <mat-radio-button [value]="token" class="token-option">
          <div class="token-details">
            <div class="token-account">
              <mat-icon>account_balance</mat-icon>
              <strong>{{ maskAccount(token.account) }}</strong>
              @if (token.accountType) {
                <span class="token-type">{{ token.accountType }}</span>
              }
              @if (token.isDefault) {
                <span class="default-badge">Default</span>
              }
            </div>
            @if (token.tokenDescription) {
              <div class="token-desc">{{ token.tokenDescription }}</div>
            }
          </div>
        </mat-radio-button>
      }
    </mat-radio-group>
  }
</div>
